import React from 'react';
import { Media, Form, Input, FormGroup, Button } from 'reactstrap';
import { searchApprovedMemberDetailsForAdmin, setSortProperty, setMemberPerPage, setSearchInProgress, setpageNumber, setAdminFiltersApproveMembers, getCityListForAdmin } from '../../../actions/MemberDirectoryAction';
import { addressDetail } from '../../../actions/AddressDetailsAction'
import { connect } from 'react-redux';
import MemberDetail from './MemberDetail';
import { AjaxLoader } from '../../AjaxLoader';
import "react-datepicker/dist/react-datepicker.css";
import NoItemFound from '../../NoItemFoundPage';
import CommonFunction from './../../../common/CommonFunction';
class ApprovedMemberDirectory extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            country: '',
            personName: '',
            email: ''
        }
    }
    componentDidMount() {
        this.props.addressDetail();

        let searchFilters = {
            IsSortByApprovalDateNew: true,
            MemberPerPage: this.props.memberPerPage,
            Active: this.props.active,
        }
        this.props.searchMemberDetailsForAdmin(searchFilters);
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.country !== prevState.country) {
            this.props.getCityListForAdmin(this.state.country);
        }
    }

    handleChange = (type, event) => {
        switch (type) {
            case "country":
                this.props.setAdminFiltersApprovedMember(event.target.value, "", this.props.sortByApprovalDate, this.props.active);
                this.setState({ country: event.target.value })
                break;
            case "city":
                this.props.setAdminFiltersApprovedMember(this.props.country, event.target.value, this.props.sortByApprovalDate, this.props.active);
                break;
            case "status":
                this.props.setAdminFiltersApprovedMember(this.props.country, this.props.city, this.props.sortByApprovalDate, event.target.value);
                break;
            case "sortByApproval":
                this.props.setAdminFiltersApprovedMember(this.props.country, this.props.city, event.target.value, this.props.active);
                break;
            case "personName":
                this.setState({ personName: event.target.value })
                break;
            case "email":
                this.setState({ email: event.target.value })
                break;
        }
    }

    createCountryName = () => {
        if (this.props.address.country.length > 0) {
            return this.props.address.country.map((country) =>
                <option key={country.countryName} value={country.countryName}>{country.countryName}</option>
            );
        }
    }
    onPerPageChange = (e) => {
        this.props.setMemberPerPage(parseInt(e.target.value));
        this.props.setpageNumber(0)
        let searchFilters = {
            City: this.props.city,
            Country: this.props.country,
            IsSortByApprovalDateNew: this.props.sortByApprovalDate === "Select" ? true : CommonFunction.CheckIfFilterIsTrue(this.props.sortByApprovalDate),
            MemberPerPage: parseInt(e.target.value),
            PageNumber: 0,
            Active: this.props.active,
            MemberName: this.state.personName,
            Email: this.state.email
        }
        this.props.searchMemberDetailsForAdmin(searchFilters);
    }

    searchMember = () => {
        this.props.setSearchInProgress();
        let searchFilters = {
            City: this.props.city,
            Country: this.props.country,
            IsSortByApprovalDateNew: this.props.sortByApprovalDate === "Select" ? true : CommonFunction.CheckIfFilterIsTrue(this.props.sortByApprovalDate),
            MemberPerPage: this.props.memberPerPage,
            PageNumber: 0,
            Active: this.props.active,
            MemberName: this.state.personName,
            Email: this.state.email
        }
        this.props.searchMemberDetailsForAdmin(searchFilters);
    }

    handlePreviousPageClick = () => {
        if (this.props.pageNumber !== 0) {
            this.props.setpageNumber(this.props.pageNumber - 1)
            let searchFilters = {
                City: this.props.city,
                Country: this.props.country,
                IsSortByApprovalDateNew: this.props.sortByApprovalDate === "Select" ? true : CommonFunction.CheckIfFilterIsTrue(this.props.sortByApprovalDate),
                MemberPerPage: this.props.memberPerPage,
                PageNumber: this.props.pageNumber - 1,
                Active: this.props.active,
                MemberName: this.state.personName,
                Email: this.state.email
            }
            this.props.searchMemberDetailsForAdmin(searchFilters);
        }
    }
    handleNextPageClick = () => {
        if (this.props.totalPageCount !== this.props.pageNumber) {
            this.props.setpageNumber(this.props.pageNumber + 1)
            let searchFilters = {
                City: this.props.city,
                Country: this.props.country,
                IsSortByApprovalDateNew: this.props.sortByApprovalDate === "Select" ? true : CommonFunction.CheckIfFilterIsTrue(this.props.sortByApprovalDate),
                MemberPerPage: this.props.memberPerPage,
                PageNumber: this.props.pageNumber + 1,
                Active: this.props.active,
                MemberName: this.state.personName,
                Email: this.state.email
            }
            this.props.searchMemberDetailsForAdmin(searchFilters);
        }
    }

    createCityName = () => {
        if (this.props.cityList.length > 0) {
            return this.props.cityList.map((city) =>
                <option key={city} value={city} > {city}</option>
            );
        }
    }

    render() {
        return (
                <React.Fragment>
                    <Form className="row mb-3 mb-md-4">
                        <FormGroup className="col-12 col-md-3 select-wrapper matrimonials-select">
                            <Input className="bg-transparent  border-dark" type="select" name="status" id="status" placeholder="status" onChange={(event) => this.handleChange("status", event)}>
                                <option value="1">Active</option>
                                <option value="0">InActive</option>
                            </Input>
                        </FormGroup>
                        <FormGroup className="col-12 col-md-3">
                            <Input className="bg-transparent border-dark" type="text" name="personName " id="personName" onChange={(event) => this.handleChange("personName", event)} placeholder="--PersonName--" />
                        </FormGroup>
                        <FormGroup className="col-12 col-md-3">
                            <Input className="bg-transparent border-dark" type="text" name="email " id="email" onChange={(event) => this.handleChange("email", event)} placeholder="--Email--" />
                        </FormGroup>

                        <FormGroup className="col-12 col-md-3 select-wrapper matrimonials-select">
                            <Input className="bg-transparent  border-dark" type="select" name="country" id="country" placeholder="country" onChange={(event) => this.handleChange("country", event)}>
                                <option value="Select">--Country--</option>
                                {this.createCountryName()}
                            </Input>
                        </FormGroup>
                        <FormGroup className="col-12 col-md-3 select-wrapper matrimonials-select">
                            <Input className="bg-transparent border-dark" type="select" name="city" id="city" onChange={(event) => this.handleChange("city", event)} >
                                <option value="Select">--City--</option>
                                {this.createCityName()}
                            </Input>
                    </FormGroup>
                    <FormGroup className="col-12 col-md-3 select-wrapper matrimonials-select">
                        <Input className="bg-transparent  border-dark" type="select" name="sort" id="sort" placeholder="Sort By" onChange={(event) => this.handleChange("sortByApproval", event)}>
                            <option value="Select">--Sort By Approve Date--</option>
                            <option value="true">Newest</option>
                            <option value="false">Oldest</option>
                        </Input>
                    </FormGroup>
                        <div className="col-12 col-md-3">
                            <Button onClick={(event) => this.searchMember(event)} className="search-button bg-primary border-0 text-white">Search</Button>
                        </div>
                    </Form>
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="font-weight-bold">List of all Members</div>
                        <div className="d-flex align-items-center">Per page:
                                    <div className="select-wrapper per-page-item">
                                <Input type="select" name="country" id="country" placeholder="country" onChange={(event) => this.onPerPageChange(event)} className="item-per-page d-inline bg-transparent border-dark ml-1">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="50">50</option>
                                </Input>
                            </div>
                        </div>
                    </div>
                    {
                        this.props.address.country.length > 0 ?
                            <div>
                                <div className="col-md-12 py-3 px-0 m-0">
                                    <AjaxLoader isOpen={this.props.isLoading} />
                                {this.props.memberDetailsAdmin.length > 0 ? < MemberDetail approve={true}/> : <NoItemFound />}
                                </div>
                                <div className="d-flex justify-content-end">
                                    <button onClick={this.handlePreviousPageClick} className={`detail-button ${this.props.totalPageCount > 1 && this.props.pageNumber !== 0 ? "d-block" : "d-none"}`}>Previous</button>
                                    <button onClick={this.handleNextPageClick} className={`detail-button ${this.props.totalPageCount > 1 && this.props.pageNumber !== this.props.totalPageCount - 1 ? "d-block" : "d-none"}`}>Next</button>
                                </div> </div> : null
                    }

                </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        memberDetailsAdmin: state.MemberDirectoryReducer.memberDetailsAdmin,
        sortByApprovalDate: state.MemberDirectoryReducer.sortByApprovalDate,
        memberPerPage: state.MemberDirectoryReducer.memberPerPage,
        pageNumber: state.MemberDirectoryReducer.pageNumber,
        isLoading: state.MemberDirectoryReducer.isLoading,
        totalPageCount: state.MemberDirectoryReducer.totalPageCount,
        address: state.AddressDetailReducer.address,
        country: state.MemberDirectoryReducer.country,
        city: state.MemberDirectoryReducer.city,
        cityList: state.MemberDirectoryReducer.cityList,
        active: state.MemberDirectoryReducer.active,
    };
}

const mapDispatchToProps = dispatch => ({
    searchMemberDetailsForAdmin: (memberSearchFilters) => {
        dispatch(searchApprovedMemberDetailsForAdmin(memberSearchFilters));
    },
    setSortProperty: (isIncreasingOrder) => {
        dispatch(setSortProperty(isIncreasingOrder));
    },
    setMemberPerPage: (memberPerPage) => {
        dispatch(setMemberPerPage(memberPerPage));
    },
    setpageNumber: (pageNumber) => {
        dispatch(setpageNumber(pageNumber));
    },
    setSearchInProgress: () => {
        dispatch(setSearchInProgress());
    },
    addressDetail: () => {
        dispatch(addressDetail());
    },
    setAdminFiltersApprovedMember: (country, city, sortByApprovalDate, active) => {
        dispatch(setAdminFiltersApproveMembers(country, city, sortByApprovalDate, active));
    },
    getCityListForAdmin: (countryName) => {
        dispatch(getCityListForAdmin(countryName));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(ApprovedMemberDirectory);

